import { NOTIFICATION_TYPES } from 'Constants'

import { API_TIMEOUT_ERROR } from 'Redux/Types/ErrorTypes'

import { UPDATE_RECEIPT_FAILED } from 'Redux/Types/ReceiptTypes'

import {
  UPDATE_USER_FAILED,
  UPDATE_USER_SUCCEEDED,
  CREATE_USER_INBOX_FAILED,
  CREATE_USER_INBOX_SUCCEEDED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED,
} from 'Redux/Types/UserTypes'

import {
  ADD_VENDOR_ALIAS_FAILED,
  ADD_VENDOR_ALIAS_SUCCEEDED,
  CHANGE_VENDOR_ALIAS_FAILED,
  CHANGE_VENDOR_ALIAS_SUCCEEDED,
  DELETE_VENDOR_ALIAS_FAILED,
  DELETE_VENDOR_ALIAS_SUCCEEDED,
  ADD_VENDOR_TAG_FAILED,
  ADD_VENDOR_TAG_SUCCEEDED,
  CHANGE_VENDOR_TAG_FAILED,
  CHANGE_VENDOR_TAG_SUCCEEDED,
  DELETE_VENDOR_TAG_FAILED,
  DELETE_VENDOR_TAG_SUCCEEDED,
} from 'Redux/Types/VendorTypes'
import { CREATE_VENDOR_SUCCEEDED, CREATE_VENDOR_FAILED } from 'Redux/Types/SearchVendorTypes'

import {
  DELETE_EXPENSE_FAILED,
  UPDATE_EXPENSE_SUCCEEDED,
  UPDATE_EXPENSE_FAILED,
  ATTACH_DOCUMENTS_SUCCEEDED,
  ATTACH_DOCUMENTS_FAILED,
  DELETE_ATTACHMENT_SUCCEEDED,
  DELETE_ATTACHMENT_FAILED,
} from 'Redux/Types/LedgerTypes'

import { ADD_GL_CODE_FAILED, ADD_GL_CODE_SUCCEEDED } from 'Redux/Types/GLCodeTypes'

import { UPDATE_PASSWORD_SUCCEEDED, UPDATE_PASSWORD_FAILED } from 'Redux/Types/PasswordResetTypes'
import { SHOW_REGISTRATION_ERROR } from 'Redux/Types/UserTypes'

import {
  CLEAR_SNACKBAR_MESSAGE,
  HIDE_SNACKBAR_NOTIFICATION,
  SHOW_SNACKBAR_NOTIFICATION,
} from 'Redux/Types/SnackbarNotificationTypes'

import {
  CREATE_REPORT_FAILED,
  DELETE_REPORT_FAILED,
  UPDATE_REPORT_FAILED,
} from 'Redux/Types/ReportTypes'

import {
  SYNC_EXPORT_DATA_SUCCEEDED,
  SYNC_EXPORT_DATA_FAILED,
  SYNC_EXPORT_NO_RECORDS_SELECTED,
} from 'Redux/Types/DataIntegrationTypes'

import * as userManagementTypes from 'Redux/Types/UserManagementTypes'

import {
  API_TIMEOUT_ERROR_NOTIFICATION,
  ADD_GL_CODE_FAILED_NOTIFICATION,
  ADD_VENDOR_ALIAS_FAILED_NOTIFICATION,
  ADD_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
  CHANGE_VENDOR_ALIAS_FAILED_NOTIFICATION,
  CHANGE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
  CREATE_USER_INBOX_FAILED_NOTIFICATION,
  CREATE_USER_INBOX_SUCCEEDED_NOTIFICATION,
  DELETE_LEDGER_RECORD_FAILED_NOTIFICATION,
  DELETE_VENDOR_ALIAS_FAILED_NOTIFICATION,
  DELETE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
  PASSWORD_UPDATE_FAILED_NOTIFICATION,
  PASSWORD_UPDATE_SUCCESS_NOTIFICATION,
  REGISTER_USER_FAILED_NOTIFICATION,
  UPDATE_RECEIPT_FAILED_NOTIFICATION,
  UPDATE_RECEIPT_SUCCEEDED_NOTIFICATION,
  UPDATE_USER_FAILED_NOTIFICATION,
  UPDATE_USER_SUCCEEDED_NOTIFICATION,
  ATTACHMENT_ADDED_NOTIFICATION,
  ATTACHMENT_ADD_FAILED_NOTIFICATION,
  ATTACHMENT_DELETED_NOTIFICATION,
  ATTACHMENT_DELETE_FAILED_NOTIFICATION,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED_NOTIFICATION,
  RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED_NOTIFICATION,
  CREATE_VENDOR_FAILED_NOTIFICATION,
  CREATE_VENDOR_SUCCEEDED_NOTIFICATION,
  ADD_GL_CODE_SUCCEEDED_NOTIFICATION,
  CREATE_REPORT_FAILED_NOTIFICATION,
  DELETE_REPORT_FAILED_NOTIFICATION,
  UPDATE_REPORT_FAILED_NOTIFICATION,
  RESEND_INVITE_SUCCEED_NOTIFICATION,
  ADD_USER_FAILED_NOTIFICATION,
  CREATE_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION,
  CREATE_EXPENSE_CATEGORY_FAILED_NOTIFICATION,
  CREATE_PROPERTY_NAME_SUCCEEDED_NOTIFICATION,
  CREATE_PROPERTY_NAME_FAILED_NOTIFICATION,
  CREATE_UNIT_NO_SUCCEEDED_NOTIFICATION,
  CREATE_UNIT_NO_FAILED_NOTIFICATION,
  EXPORT_SYNC_FAILED_NOTIFICATION,
  EXPORT_SYNC_SUCCEEDED_NOTIFICATION,
  SYNC_EXPORT_NO_RECORDS_SELECTED_NOTIFICATION,
} from 'Constants/notifications'
import {
  ADD_EXPENSE_CATEGORY_FAILED,
  ADD_EXPENSE_CATEGORY_SUCCEEDED,
} from '../Types/ExpenseCategoryTypes'
import { ADD_PROPERTY_NAME_FAILED, ADD_PROPERTY_NAME_SUCCEEDED } from '../Types/PropertyNameTypes'
import { ADD_UNIT_NO_FAILED, ADD_UNIT_NO_SUCCEEDED } from 'Redux/Types/UnitNoTypes'

const { SUCCESS, ERROR } = NOTIFICATION_TYPES

const INITIAL_STATE = {
  queue: [],
  open: false,
}

const failedNotificationState = (state, error, defaultMessage, payload) => {
  const payloadError = payload && payload.error ? payload.error : payload
  return {
    ...state,
    open: true,
    type: ERROR,
    message: error && payloadError && payloadError.message ? payloadError.message : defaultMessage,
  }
}

const successNotificationState = (state, message, defaultMessage) => ({
  ...state,
  open: true,
  type: SUCCESS,
  message: message || defaultMessage,
})

export default (state = INITIAL_STATE, { type, payload, error }) => {
  error = error || (payload && payload.error)

  switch (type) {
    case HIDE_SNACKBAR_NOTIFICATION:
      return {
        ...state,
        open: false,
      }
    case SHOW_SNACKBAR_NOTIFICATION:
      return {
        ...state,
        open: true,
        message: payload.message,
        type: payload.type,
      }

    case CLEAR_SNACKBAR_MESSAGE:
      return INITIAL_STATE

    case ADD_GL_CODE_FAILED:
      return failedNotificationState(state, error, ADD_GL_CODE_FAILED_NOTIFICATION)

    case UPDATE_USER_FAILED:
      return failedNotificationState(state, error, UPDATE_USER_FAILED_NOTIFICATION)
    case UPDATE_USER_SUCCEEDED: {
      const { successMessage } = payload || {}
      return successNotificationState(state, successMessage, UPDATE_USER_SUCCEEDED_NOTIFICATION)
    }

    case RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED:
      return failedNotificationState(
        state,
        error,
        RESEND_ACCOUNT_VERIFICATION_EMAIL_FAILED_NOTIFICATION,
      )
    case RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED: {
      const { successMessage } = payload || {}
      return successNotificationState(
        state,
        successMessage,
        RESEND_ACCOUNT_VERIFICATION_EMAIL_SUCCEEDED_NOTIFICATION,
      )
    }

    case UPDATE_RECEIPT_FAILED:
      return failedNotificationState(state, error, UPDATE_RECEIPT_FAILED_NOTIFICATION)

    case UPDATE_EXPENSE_SUCCEEDED:
      return successNotificationState(state, error, UPDATE_RECEIPT_SUCCEEDED_NOTIFICATION)

    case UPDATE_EXPENSE_FAILED:
      return failedNotificationState(state, error, UPDATE_RECEIPT_FAILED_NOTIFICATION)

    case SYNC_EXPORT_DATA_SUCCEEDED:
      return successNotificationState(state, error, EXPORT_SYNC_SUCCEEDED_NOTIFICATION)

    case SYNC_EXPORT_DATA_FAILED:
      return failedNotificationState(state, error, EXPORT_SYNC_FAILED_NOTIFICATION)

    case SYNC_EXPORT_NO_RECORDS_SELECTED:
      return failedNotificationState(state, error, SYNC_EXPORT_NO_RECORDS_SELECTED_NOTIFICATION)

    case CREATE_USER_INBOX_FAILED: {
      return failedNotificationState(state, error, CREATE_USER_INBOX_FAILED_NOTIFICATION, payload)
    }
    case CREATE_USER_INBOX_SUCCEEDED:
      return successNotificationState(
        state,
        payload && payload.successMessage,
        CREATE_USER_INBOX_SUCCEEDED_NOTIFICATION,
      )

    case ADD_VENDOR_ALIAS_FAILED:
      return failedNotificationState(state, error, ADD_VENDOR_ALIAS_FAILED_NOTIFICATION, payload)
    case ADD_VENDOR_ALIAS_SUCCEEDED:
      return successNotificationState(
        state,
        payload.successMessage,
        ADD_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
      )

    case CHANGE_VENDOR_ALIAS_FAILED:
      return failedNotificationState(state, error, CHANGE_VENDOR_ALIAS_FAILED_NOTIFICATION)
    case CHANGE_VENDOR_ALIAS_SUCCEEDED:
      return successNotificationState(
        state,
        payload.successMessage,
        CHANGE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
      )

    case DELETE_VENDOR_ALIAS_FAILED:
      return failedNotificationState(state, error, DELETE_VENDOR_ALIAS_FAILED_NOTIFICATION)
    case DELETE_VENDOR_ALIAS_SUCCEEDED:
      return successNotificationState(
        state,
        payload.successMessage,
        DELETE_VENDOR_ALIAS_SUCCEEDED_NOTIFICATION,
      )

    case CREATE_VENDOR_FAILED:
      return failedNotificationState(state, error, CREATE_VENDOR_FAILED_NOTIFICATION)
    case CREATE_VENDOR_SUCCEEDED:
      return successNotificationState(state, CREATE_VENDOR_SUCCEEDED_NOTIFICATION)

    case ADD_GL_CODE_SUCCEEDED:
      return successNotificationState(state, error, ADD_GL_CODE_SUCCEEDED_NOTIFICATION)

    case ADD_EXPENSE_CATEGORY_SUCCEEDED:
      return successNotificationState(state, error, CREATE_EXPENSE_CATEGORY_SUCCEEDED_NOTIFICATION)
    case ADD_EXPENSE_CATEGORY_FAILED:
      return failedNotificationState(state, CREATE_EXPENSE_CATEGORY_FAILED_NOTIFICATION)
    case ADD_PROPERTY_NAME_SUCCEEDED:
      return successNotificationState(state, error, CREATE_PROPERTY_NAME_SUCCEEDED_NOTIFICATION)
    case ADD_PROPERTY_NAME_FAILED:
      return failedNotificationState(state, CREATE_PROPERTY_NAME_FAILED_NOTIFICATION)
    case ADD_UNIT_NO_SUCCEEDED:
      return successNotificationState(state, error, CREATE_UNIT_NO_SUCCEEDED_NOTIFICATION)
    case ADD_UNIT_NO_FAILED:
      return failedNotificationState(state, CREATE_UNIT_NO_FAILED_NOTIFICATION)

    case ADD_VENDOR_TAG_FAILED:
      return failedNotificationState(state, error, null, payload)
    case ADD_VENDOR_TAG_SUCCEEDED:
      return successNotificationState(state, payload.successMessage)

    case CHANGE_VENDOR_TAG_FAILED:
      return failedNotificationState(state, error, null, payload)
    case CHANGE_VENDOR_TAG_SUCCEEDED:
      return successNotificationState(state, payload.successMessage)

    case DELETE_VENDOR_TAG_FAILED:
      return failedNotificationState(state, error, null, payload)
    case DELETE_VENDOR_TAG_SUCCEEDED:
      return successNotificationState(state, payload.successMessage)

    case DELETE_EXPENSE_FAILED:
      return failedNotificationState(state, error, DELETE_LEDGER_RECORD_FAILED_NOTIFICATION)

    case UPDATE_PASSWORD_SUCCEEDED: {
      return successNotificationState(state, '', PASSWORD_UPDATE_SUCCESS_NOTIFICATION)
    }

    case UPDATE_PASSWORD_FAILED: {
      // Show error in form if password matches current password or is incorrect
      if (payload.code === 'INCORRECT_PARAMS' || payload.code === 'POLICY_VIOLATION_PASSWORD') {
        return state
      }

      return failedNotificationState(state, '', PASSWORD_UPDATE_FAILED_NOTIFICATION)
    }

    case SHOW_REGISTRATION_ERROR: {
      return failedNotificationState(state, error, REGISTER_USER_FAILED_NOTIFICATION)
    }

    case ATTACH_DOCUMENTS_FAILED:
      return failedNotificationState(state, error, ATTACHMENT_ADD_FAILED_NOTIFICATION)

    case DELETE_ATTACHMENT_FAILED:
      return failedNotificationState(state, error, ATTACHMENT_DELETE_FAILED_NOTIFICATION)

    case ATTACH_DOCUMENTS_SUCCEEDED:
      return successNotificationState(state, payload.successMessage, ATTACHMENT_ADDED_NOTIFICATION)

    case DELETE_ATTACHMENT_SUCCEEDED:
      return successNotificationState(
        state,
        payload.successMessage,
        ATTACHMENT_DELETED_NOTIFICATION,
      )

    case CREATE_REPORT_FAILED:
      return failedNotificationState(state, true, CREATE_REPORT_FAILED_NOTIFICATION)

    case DELETE_REPORT_FAILED:
      return failedNotificationState(state, true, DELETE_REPORT_FAILED_NOTIFICATION)

    case UPDATE_REPORT_FAILED:
      return failedNotificationState(state, true, UPDATE_REPORT_FAILED_NOTIFICATION)

    case API_TIMEOUT_ERROR:
      return failedNotificationState(state, true, API_TIMEOUT_ERROR_NOTIFICATION)

    case userManagementTypes.RESEND_USER_INVITE_SUCCEEDED:
      return successNotificationState(state, RESEND_INVITE_SUCCEED_NOTIFICATION)

    case userManagementTypes.ADD_USER_FAILED:
      return failedNotificationState(
        state,
        true,
        payload === 'EMAIL_ALREADY_REGISTERED'
          ? ADD_USER_FAILED_NOTIFICATION
          : API_TIMEOUT_ERROR_NOTIFICATION,
      )

    default:
      return state
  }
}
